import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import {
  TuiDataList,
  TuiError,
  TuiNumberFormat,
  TuiInput,
  TuiDropdown,
  TuiTextfield,
  TuiLabel,
  TuiCalendar,
} from '@taiga-ui/core';
import {
  TuiInputNumber,
  TuiSelect,
  TuiInputDate,
  TuiInputTime,
  TuiChevron,
} from '@taiga-ui/kit';
import { TranslatePipe } from '@ngx-translate/core';
import type { CarBrand } from '@core/types';

@Component({
  selector: 'x-request-create-step-1b',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    TuiTextfield,
    TuiLabel,
    TuiChevron,
    TuiCalendar,
    ReactiveFormsModule,
    TuiInput,
    TuiInputDate,
    TuiInputTime,
    TuiInputNumber,
    TuiSelect,
    TuiDataList,
    TuiError,
    TranslatePipe,
    TuiNumberFormat,
    TuiDropdown,
  ],
  templateUrl: './step-1b-vehicle-delivery.component.html',
})
export class RequestCreateStep1bComponent {
  readonly form = input.required<FormGroup>();
  readonly carBrands = input<CarBrand[]>([]);

  readonly stringifyCarBrand = (id: number): string => {
    const found = this.carBrands().find(b => b.id === id);

    return found?.name ?? '';
  };
}
